<template>    
  <div
    class="results-table__cell"
    :title="cellValue"
  >
    <span>
      {{ cellValue }} 
    </span>
  </div>
</template>

<script>
/* eslint-disable */
import tableFunctions from '@src/utils/tableFunctions'

import { cellMixins } from './mixins'

export default {
  mixins: [cellMixins],

  data() {
    return {
      cellMethods: tableFunctions 
    }
  },

  computed: {
    cellValue() {
      let args = []

      this.cellData.dataFields.forEach(item =>{
        args.push(this.docData[item])
      })

      return this.cellMethods[this.cellData.options.action](args)
    }
  }
};
</script>
